import React, { useState, useContext } from "react";
import { Box, Grid, Paper, Chip, Typography , CircularProgress  } from "@mui/material";
import { useDroppable } from "@dnd-kit/core";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import moment from "moment";
import Modal from 'react-bootstrap/Modal';
import TicketModal from "./TicketModal";
import AuthContext from "../../context/AuthContext";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { DeleteModal, EditModal } from "./TicketModals";
import ApiService from '../../functions/apiService';
import './ticketing.css'
import { Row , Col } from "react-bootstrap";

export const SortableItem = ({ item, activeItem, ticketApi, ticketType  }) => {
  const { user } = useContext(AuthContext);
  const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id: item.id });
  const limit = 50;
  const titleLimit = 13;
  const [show, setShow] = useState(false);
	const [deleteModal , setDeleteModal] = useState(false);
	const [editModal , setEditModal] = useState(false);
	const [editId , setEditId] = useState('');
	const [loading , setLoading] = useState(false);

  const style = {
		transform: CSS.Transform.toString(transform),
		transition,
		padding: "16px",
		marginBottom: "16px",
		backgroundColor: "white",
		borderRadius: "8px",
		boxShadow: "0px 2px 6px rgba(0, 0, 0, 0.1)",
		cursor: "grab",
		maxWidth: "100%",
	};

	if (activeItem?.id === item.id) {
    return <></>; 
  }

  return (
    <>
			<Box ref={setNodeRef} {...attributes} {...listeners} sx={style} onClick={(e) => e.stopPropagation()}>
				<Grid container spacing={2} sx={{paddingLeft:'16px' , paddingTop:'12px' , paddingRight:'12px'}}>
					<Grid md={9} sm={9}>
						<Typography 
							fontWeight={600}
							sx={{
								whiteSpace: 'nowrap',
								overflow: 'hidden',
								textOverflow: 'ellipsis',
							}}
						>{item?.content || 'No Title'}</Typography>
					</Grid>
					<Grid md={3} sm={3}>
						<div>
							<u style={{ fontSize: '14px', cursor: 'pointer', color: '#D92D20' }} onClick={() => setShow(true)}>Details →</u>
						</div>
					</Grid>
				</Grid>

				<div style={{height:'1px' , backgroundColor:'#EAECF0' , marginTop:'10px'}}></div>

				<div style={{ marginTop: '10px' }}>
					<Typography sx={{ fontSize: '14px', color: '#777777' }}>
						{item?.description ? `${item.description.substring(0, limit)}...` : " "}
					</Typography>

					<Typography sx={{ fontSize: '14px', marginTop: '8px' }}>
						<strong>Assigned to :</strong> {item?.employee_first_name} {item?.employee_last_name}
					</Typography>

					<Typography sx={{ fontSize: '14px', marginBottom: '8px' }}>
						<strong>Date:</strong> {moment(item.date).format('DD/MM/YYYY')}
					</Typography>

					<div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' , marginTop:'10px' }}>
						{item?.employee_code == user?.Emp_Code && ticketType === 'allTicket' && (
							<div style={{ background: '#ECFDF3', color: '#12B76A', fontSize: '12px', borderRadius: '16px', padding: '2px 10px' }}>
								My Ticket
							</div>
						)}

						<div style={{ display: 'flex', alignItems: 'center', gap: '6px' , cursor:'pointer' }}>
							{item?.Assigned_by == user?.Emp_Code &&
								<EditIcon sx={{ height: '20px', width: '20px', color: '#555555' , cursor:'pointer' }} 
									onClick={()=> {
										setEditModal(true)
										setEditId(item?.id)
									}}/>
							}
							{item?.Assigned_by == user?.Emp_Code &&
								<DeleteIcon sx={{ height: '20px', width: '20px', color: '#555555' , cursor:'pointer'}} 
									onClick={()=> 
										setDeleteModal(true)}
								/>
							}
							{item.image && (
								<div style={{ textAlign: 'right', marginLeft:'4px' }}>
									<a href={item.image} target="_blank" rel="noopener noreferrer">
										<img
											src={item.image}
											height="24px"
											width="24px"
											style={{
												borderRadius: '50%',
												border: '1px solid #cccccc',
												cursor: 'pointer',
											}}
										/>
									</a>
								</div>
							)}
							{item.secondaryImage	 && (
								<div style={{ textAlign: 'right', marginLeft:'4px' }}>
									<a href={item.secondaryImage} target="_blank" rel="noopener noreferrer">
										<img
											src={item.secondaryImage}
											height="24px"
											width="24px"
											style={{
												borderRadius: '50%',
												border: '1px solid #cccccc',
												cursor: 'pointer',
											}}
										/>
									</a>
								</div>
							)}
						</div>
					</div>
				</div>
			</Box>


      <Modal show={show} onHide={() => {
				setShow(false)
				ticketApi()
			}} size='xl'>
        <Modal.Body className='p-0'>
          <TicketModal
            show={show}
            setShow={setShow}
            item={item}
            ticketApi={ticketApi}
          />
        </Modal.Body>
      </Modal>

			<Modal show={deleteModal} onHide={() => {
					setDeleteModal(false)
				}} size='md'>
					<Modal.Header closeButton>
						<Modal.Title>Delete Ticket</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<DeleteModal
							deleteModal = {deleteModal}
							setDeleteModal = {setDeleteModal}
							item = {item}
							ticketApi={ticketApi}
						/>
					</Modal.Body>
				</Modal>

				<Modal show={editModal} onHide={() => {
					setEditModal(false)
				}} size='md'>
					<Modal.Header closeButton>
						<Modal.Title>Edit Ticket</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<EditModal
							editModal = {deleteModal}
							setEditModal = {setEditModal}
							item = {item}
							ticketApi={ticketApi}
							editId = {editId}
						/>
					</Modal.Body>
				</Modal>
			</>
  );
};

export const DroppableColumn = ({ columnId, column, children }) => {
  const { setNodeRef } = useDroppable({ id: columnId });

  return (
    <Paper
      ref={setNodeRef}
      style={{
        padding: "1rem",
        backgroundColor: "#f5f5f5",
        borderTop: "5px solid #cccccc",
        borderRadius: "12px",
        marginBottom: '10px'
      }}
    >
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <Chip label={column.name} color="primary" className="px-3" />
        <p>{column.items.length} Tickets</p>
      </div>
      <Box
        sx={{
          height: "100vh",
          overflow: "scroll",
          marginTop: "16px",
          scrollbarWidth: "none",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
        {column.items.length === 0 && (
          <>
            <p style={{ textAlign: "center", color: "#aaaaaa" }}>No items in {column.name}</p>
          </>
        )}
      </Box>
    </Paper>
  );
};
